import { createFeatureSelector, createSelector } from '@ngrx/store';

export const SharedForcesSelector = createFeatureSelector('sharedForces');
